import { URLS } from "@constants/urls";
import api from "@helpers/api";
import axios from "axios";
import fileDownload from "js-file-download";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/unit-positions/tree-view`;

const apiEndPointForDownload = `${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.REPORTS}`;

export const fetchPositionsTree = async (queries: any) => {
  try {
    const res = await api.get(`${apiEndPoint}`, {
      params: {
        ...queries,
      },
    });
    const resData = await res.data;
    return {
      resData,
      status: "SUCCESS",
    };
  } catch (error) {
    return {
      status: "FAILED",
      error,
    };
  }
};

export const downloadTreeWiseReport = async (
  token: string,
  fileName: string,
  queries: any,
) => {
  try {
    const res = await axios.get(
      `${apiEndPointForDownload}/pdf/tree-wise-employee-info`,
      {
        params: {
          ...queries,
        },
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    fileDownload(res.data, `${fileName}.pdf`);
  } catch (error) {
    alert("Error downloading file");
  }
};
